export const destinations = [
  // Featured National Destinations
  {
    id: 1,
    name: "Fernando de Noronha",
    description: "Paraíso natural com praias cristalinas",
    image: "/places/noronha.png",
    category: "national"
  },
  {
    id: 2,
    name: "Rio de Janeiro",
    description: "Cidade maravilhosa com praias e cultura vibrante",
    image: "/places/rj.png",
    category: "national"
  },
  {
    id: 3,
    name: "Foz do Iguaçu",
    description: "Cataratas majestosas e natureza exuberante",
    image: "/places/fozDoIguacu.png",
    category: "national"
  },
  {
    id: 4,
    name: "Porto de Galinhas",
    description: "Praias paradisíacas e piscinas naturais",
    image: "/places/portoDeGalinhas.png",
    category: "national"
  },
  {
    id: 5,
    name: "Gramado",
    description: "Charme europeu e gastronomia única",
    image: "/places/gramado.png",
    category: "national"
  },
  {
    id: 6,
    name: "Salvador",
    description: "História, cultura e praias deslumbrantes",
    image: "/places/salvador.png",
    category: "national"
  },
  // Featured International Destinations
  {
    id: 7,
    name: "Paris",
    description: "Cidade luz, romance e cultura",
    image: "/places/paris.png",
    category: "international"
  },
  {
    id: 8,
    name: "Nova Iorque",
    description: "A cidade que nunca dorme",
    image: "/places/ny.png",
    category: "international"
  },
  {
    id: 9,
    name: "Lisboa",
    description: "História, charme e tradição portuguesa",
    image: "/places/lisboa.jpg",
    category: "international"
  },
  {
    id: 10,
    name: "Madri",
    description: "Arte, cultura e gastronomia espanhola",
    image: "/places/madri.png",
    category: "international"
  },
  {
    id: 11,
    name: "Buenos Aires",
    description: "Tango, história e arquitetura única",
    image: "/places/buenosAires.png",
    category: "international"
  },
  {
    id: 12,
    name: "Munique",
    description: "Tradição alemã e festivais icônicos",
    image: "/places/munique.png",
    category: "international"
  },
  {
    id: 13,
    name: "Bangkok",
    description: "Arte, cultura e gastronomia tailandesa",
    image: "/places/bangkok.png",
    category: "international"
  }
];

// All available destinations for reference
export const allDestinations = {
  national: [
    "Porto de Galinhas",
    "Gramado",
    "Maceió",
    "Curitiba",
    "Recife",
    "Aracaju",
    "Fernando de Noronha",
    "São Paulo",
    "Rio de Janeiro",
    "Salvador",
    "Florianopólis",
    "Brasília",
    "Foz do Iguaçu",
    "Manaus",
    "Marabá",
    "Belém"
  ],
  international: [
    "Madri",
    "Cali",
    "Lisboa",
    "Munique",
    "Palma de Maiorca",
    "Buenos Aires",
    "Paris",
    "Nova Iorque"
  ]
};